"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _localization = require("@lt/localization");
var _HotelOfferPrice = _interopRequireWildcard(require("../HotelOfferPrice"));
var _Button = _interopRequireDefault(require("../Button"));
var _index = require("../../proptypes/hotel/index");
var _excluded = ["operatorName", "onClick", "included"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var subTextArray = [_localization.i18n.t('hotel.offer.withFlight')];
var HotelOfferItem = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var operatorName = _ref.operatorName,
    onClick = _ref.onClick,
    included = _ref.included,
    priceProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var includedServices = included.map(function (item) {
    return String(item.name).toLowerCase();
  });
  return /*#__PURE__*/_react["default"].createElement(StyledOfferitem, {
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(FlexContainer, null, /*#__PURE__*/_react["default"].createElement(StyledText, null, operatorName), /*#__PURE__*/_react["default"].createElement(StyledHotelOfferPrice, priceProps)), /*#__PURE__*/_react["default"].createElement(StyledSubText, null, [].concat(subTextArray, (0, _toConsumableArray2["default"])(includedServices)).join(', ')));
});
HotelOfferItem.displayName = 'HotelOfferItem';
var StyledHotelOfferPrice = (0, _styledComponents["default"])(_HotelOfferPrice["default"]).withConfig({
  displayName: "HotelOfferItem__StyledHotelOfferPrice",
  componentId: "sc-a0uaat-0"
})(["", "{font-size:14px;color:", ";}"], _HotelOfferPrice.StyledPrice, function (props) {
  return props.theme.colors.blackBase;
});
var StyledOfferitem = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "HotelOfferItem__StyledOfferitem",
  componentId: "sc-a0uaat-1"
})(["height:50px;width:100%;padding:10px;border-top:solid 1px transparent;&:hover{background-color:", ";}&:not(:first-child):not(:hover){border-color:#eaeaea;}"], function (props) {
  return props.theme.colors.solitude;
});
var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferItem__FlexContainer",
  componentId: "sc-a0uaat-2"
})(["display:flex;justify-content:space-between;align-items:center;"]);
var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferItem__StyledText",
  componentId: "sc-a0uaat-3"
})(["", " color:", ";text-align:left;display:flex;"], function (props) {
  return props.theme.typography.text1;
}, function (props) {
  return props.theme.colors.blackLight;
});
var StyledSubText = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferItem__StyledSubText",
  componentId: "sc-a0uaat-4"
})(["", " color:", ";text-align:left;display:flex;"], function (props) {
  return props.theme.typography.text3;
}, function (props) {
  return props.theme.colors.greyLight;
});
HotelOfferItem.defaultProps = {
  included: null
};
HotelOfferItem.propTypes = _objectSpread(_objectSpread({
  onClick: _propTypes["default"].func.isRequired,
  operatorName: _propTypes["default"].string.isRequired
}, _HotelOfferPrice["default"].propTypes), {}, {
  included: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    code_name: _propTypes["default"].string.isRequired
  }).isRequired),
  availability: _index.AvailabilityPropTypes.isRequired
});
var _default = exports["default"] = HotelOfferItem;